// extracted by mini-css-extract-plugin
export var actionText = "_nl-4";
export var container = "_nl-0";
export var leftSection = "_nl-1";
export var rightSection = "_nl-2";
export var settingsButton = "_nl-6";
export var settingsIcon = "_nl-7";
export var shortcut = "_nl-5";
export var shortcutGroup = "_nl-3";